const INLINE_IMAGE_ENCODING_SCHEME_PREFIX = 'data:image/jpeg;base64,';

/**
 * to prepend base64 image string with encoding prefix, so that it can be displayed properly
 * @param image base64 image string
 */
export const getProfilePicImage = (image: null | string | undefined) => {
  if (image) {
    return INLINE_IMAGE_ENCODING_SCHEME_PREFIX + image;
  }
  return '';
};
